import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SubMenuService } from '../../../../services/submenu.service';
import { Subscription } from 'rxjs';
import { ExitButtonComponent } from '../../../../shared/components/buttons/exit-button/exit-button.component';

@Component({
  selector: 'app-filter-page',
  standalone: true,
  imports: [CommonModule, FormsModule, ExitButtonComponent],
  templateUrl: './filter-page.component.html',
  styleUrl: './filter-page.component.scss',
})
export class FilterPageComponent implements OnInit, OnDestroy {
  isOpen = false;
  private subscription: Subscription = new Subscription();

  showDatePicker = false;

  @ViewChild('startInput') startInput!: ElementRef<HTMLInputElement>;
  @ViewChild('endInput') endInput!: ElementRef<HTMLInputElement>;

  startDate!: string;
  endDate!: string;
  @Output() close = new EventEmitter<void>();

  waypoints = [
    {
      id: 'fish-caught',
      label: 'Fish Caught',
      checked: false,
      icon: '/assets/home/filter/fishcaught_logo.svg',
    },
    {
      id: 'fish-mark',
      label: 'Fish Mark',
      checked: false,
      icon: '/assets/home/filter/fishmark_logo.svg',
    },
    {
      id: 'bait-mark',
      label: 'Bait Mark',
      checked: true,
      icon: '/assets/home/filter/baitmark_logo.svg',
    },
    {
      id: 'temp-break',
      label: 'Temp Break',
      checked: false,
      icon: '/assets/home/filter/tempbreak.svg',
    },
    {
      id: 'wreck',
      label: 'Wreck',
      checked: false,
      icon: '/assets/home/filter/wreck.svg',
    },
    {
      id: 'canyon',
      label: 'Canyon',
      checked: false,
      icon: '/assets/home/filter/canyon.svg',
    },
    {
      id: 'inlet',
      label: 'Inlet',
      checked: false,
      icon: '/assets/home/filter/inlet.svg',
    },
    {
      id: 'anchorage',
      label: 'Anchorage',
      checked: false,
      icon: '/assets/home/filter/anchor.svg',
    },
    {
      id: 'home',
      label: 'Home',
      checked: false,
      icon: '/assets/home/filter/home_logo.svg',
    },
    {
      id: 'hazard',
      label: 'Hazard',
      checked: false,
      icon: '/assets/home/filter/hazard_logo.svg',
    },
    {
      id: 'patrol',
      label: 'Patrol',
      checked: false,
      icon: '/assets/home/filter/patrol_logo.svg',
    },
    {
      id: 'diver',
      label: 'Diver',
      checked: false,
      icon: '/assets/home/filter/diver.svg',
    },
  ];

  constructor(private submenuService: SubMenuService) { }

  ngOnInit() {
    // Subscribe to filter open state
    this.startDate = '2025-05-05';
    this.endDate = '2035-05-24';
    this.subscription.add(
      this.submenuService.filterOpenState$.subscribe((state: boolean) => {
        // Use setTimeout to ensure the animation triggers properly
        setTimeout(() => {
          this.isOpen = state;
        }, 10);
      })
    );
  }
  toggleDatePicker() {
    this.showDatePicker = !this.showDatePicker;
  }

  openDatePicker() {
    this.startInput.nativeElement.showPicker();
  }

  /** After start date selected */
  onStartSelected() {
    // auto-open end date picker
    setTimeout(() => {
      this.endInput.nativeElement.showPicker();
    }, 100);
  }
  onEndSelected() {
    // auto-fix range
    if (this.startDate > this.endDate) {
      const temp = this.startDate;
      this.startDate = this.endDate;
      this.endDate = temp;
    }

    console.log('Final Date Range:', this.startDate, this.endDate);
  }

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscription.unsubscribe();
  }

  closeFilter() {
    this.isOpen = false;
    this.submenuService.setFilterOpenState(false);
    this.close.emit();
  }
}
